import { render, staticRenderFns } from "./attribute-branch.vue?vue&type=template&id=06887e64&scoped=true&"
import script from "./attribute-branch.vue?vue&type=script&lang=js&"
export * from "./attribute-branch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06887e64",
  null
  
)

export default component.exports